import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface Crumb {
  label: string;
  to?: string;
}
export function Breadcrumbs({
  items
}: {
  items: Crumb[];
}) {
  return <nav aria-label="Fil d’Ariane" className="text-xs text-muted" data-id="element-605" data-mp="fnmdx636tgr9">
      <ol className="flex flex-wrap items-center gap-1.5" data-id="element-606" data-mp="knigr205f258">
        {items.map((item, i) => <li key={item.label} className="flex items-center gap-1.5" data-id="element-607" data-mp="5z4g8xq7fpru" data-mpi={i}>
            {item.to ? <Link to={item.to} className="transition-colors duration-150 hover:text-ink" data-id="element-608" data-mp="apb24ptc0w6e">
                {item.label}
              </Link> : <span aria-current="page" className="text-ink" data-id="element-609" data-mp="3t5exetpcjn4q">
                {item.label}
              </span>}
            {i < items.length - 1 && <ChevronRightIcon className="h-3 w-3" aria-hidden data-id="element-610" data-mp="3j4us9fyphyh8" />}
          </li>)}
      </ol>
    </nav>;
}